<template>
    <div class="body">
        <div class="content">
            <img src="@/assets/mifi/title2.jpg" style="width: 100%;" />
            <p style="text-align: center; font-weight: bold; font-size: 1.5em; color: #ff0000; text-shadow: 1px 1px 2px rgba(0,0,0,0.3);">购买以下设备，均可赠送一张流量卡使用</p>
            <van-tabs @click="onClick">
                <van-tab v-for="index in vanTab" :title="index" :key="index" />
            </van-tabs>

            <mt-loadmore :bottom-method="getAgentPrechargeListHandler" :bottom-all-loaded="allLoaded" :auto-fill="false"
                ref="loadmore">
                <van-row class="el-col-row">
                    <van-col span="12" v-for="item in wifiList" :key="item.id" @click.native="linkOpen(item)">
                        <div class="item-data">
                            <img :src="item.img" alt="" />
                            <div class="goodsTitle">{{ item.shareName }}</div>
                            <div class="goodsPrc">¥{{ item.sharePrice }}</div>
                        </div>
                    </van-col>
                </van-row>
            </mt-loadmore>
            <div class="copyRight">
                <div style="text-align: center;margin-bottom:14px;">售后QQ：692217838</div>
                <div style="text-align: center;margin:14px 0;">济南工晓网络科技有限公司</div>
                <div style="text-align: center;margin-bottom:14px;">备案号：鲁ICP备2024099227号-1</div>
                <div style="text-align: center;margin-bottom:14px;">地址：山东省济南市槐荫区段店北路街道融建财富壹号广场1号楼803室</div>
            </div>
        </div>
        <div class="f-tab">
            <van-tabbar v-model="active" @change="onChange">
                <van-tabbar-item icon="home-o">首页</van-tabbar-item>
                <van-tabbar-item icon="friends-o">我的</van-tabbar-item>
            </van-tabbar>
        </div>
    </div>
</template>
<script>
import { wxRequest } from '@/api/user.js'
import { Dialog } from "vant";
export default {
    data() {
        return {
            dataList: [
                {
                    img: require('@/assets/mifi/1.jpg'), //首图
                    imga: require('@/assets/mifi/1a.jpg'),//介绍图
                    imgb: require('@/assets/mifi/1b.jpg'),//介绍图
                    shareName: 'wifi全国通用2024款无线移动网卡4g路由',
                    sharePrice: '22.99',
                    type: '1',
                    title: 'MIFI设备',
                },
                {
                    img: require('@/assets/mifi/3.jpg'),
                    imga: require('@/assets/mifi/3a.jpg'),
                    type: '1',
                    imgb: require('@/assets/mifi/3b.jpg'),
                    shareName: 'MF11 5G随身wifi免插卡流量移动路由器双频型',
                    sharePrice: '99.00',
                    title: 'MIFI设备',
                },
                {
                    img: require('@/assets/mifi/2.jpg'),
                    imga: require('@/assets/mifi/2a.jpg'),
                    imgb: require('@/assets/mifi/2b.jpg'),
                    type: '1',
                    shareName: 'DH66 随身wifi可移动无线wi-fi6免插卡',
                    sharePrice: '59.00',
                    title: 'MIFI设备',
                },
                // {
                //     img: require('@/assets/mifi/4.jpg'),
                //     imga: require('@/assets/mifi/4a.jpg'),
                //     imgb: require('@/assets/mifi/4b.jpg'),
                //     type: '2',
                //     shareName: '通用电池模块云厅型号',
                //     sharePrice: '12.99',
                //     title: '设备外设',
                // }
            ],
            active: 0,
            wifiList: [],
            pageNo: 0,
            perPageNum: 10,
            allPage: 0,
            agentId: '',
            vanTab: ['MIFI设备', '设备外设'],
            allLoaded: false,
            title: 'MIFI设备'
        }
    },
    created() {
        this.wifiList = this.dataList.filter(item => item.type === '1')
    },
    methods: {
        onClick(name, title) {
            this.title = title
            this.pageNo = 0
            this.getAgentPrechargeListHandler()
            this.wifiList = title === 'MIFI设备' ? this.dataList.filter(item => item.type === '1') : this.dataList.filter(item => item.type === '2')
        },
        getAgentPrechargeListHandler() {
            this.$refs.loadmore.onBottomLoaded();
            this.$nextTick(function () {
                window.scroll(0, 0);
            })
        },
        onChange(data) {
            console.log(data)
            if (data === 1) {
                this.$router.push({ path: '/xin/me' });
            }
        }, 
        linkOpen(data) {
            var loginPhone = localStorage.getItem('myLoginPhone');
            if (loginPhone && loginPhone.length > 5) {
                this.$router.push({ path: '/xin/buyShebeiInfo', query: { p: encodeURI(JSON.stringify(data)) } });
            } else {
                Dialog.confirm({
                    title: "注册提示",
                    message:"请先注册信息后，再进行购买操作。 点击 确定 即可前往注册。"})
                    .then(() => {
                        this.$router.push({ path: '/xin/miBindPhone' });
                    })
                    .catch(() => { });
            }
        }
    }
}
</script>
<style lang="less" scoped>
.body {
    height: auto;
    width: 100%;
    padding-bottom: 163px;
    position: relative;
    .header {
        padding-bottom: 10px;

        img {
            width: 100%;
        }
    }

    // .item-data {
    //     padding: 10px;
    //     height:283px;
    //     img {
    //         width: 100%;
    //         max-height:175px;
    //     }

    //     .goodsTitle {
    //         font-size: 14px;
    //         font-weight: bold;
    //         color: #525253;
    //         line-height: 1.2rem;
    //         height:60px;
    //     }

    //     .goodsPrc {
    //         color: #CB353B;
    //         font-size: 18px;
    //         margin-top: 10px;
    //     }
    // }
    .item-data {
        padding: 10px;

        img {
            width: 100%;
            /* // height:130px; */
        }

        .goodsTitle {
            font-size: 14px;
            font-weight: bold;
            color: #525253;
            height: 40px;
            line-height: 1.2rem;
        }

        .goodsPrc {
            color: #CB353B;
            font-size: 18px;
            margin-top: 10px;
        }
    }
}

.slecjg {
    width: 138px;
    height: 44px;
    background: #CB353B;
    font-size: 16px;
    color: #fff;
    border-radius: 22px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    bottom: 20px;
    right: 0;
    left: 0;
    margin: 0 auto;
}

.copyRight {
    position: absolute;
    bottom: 50px;
    left: 0;
    right: 0;
    margin: auto;
}
</style>